import { EnumComponentType } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { DBComponent } from '../../../../../../api/com/MetaPattern/MDA/MD/DBModel/DBComponent';

export class DBComponentExtend {
  public static Init(dto: DBComponent) {
    dto.componentType = EnumComponentType.DB;
  }
}
